export default "__VITE_ASSET__eAlmaGzL__"